export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";